/* eslint-disable default-param-last */
import { createSlice } from "@reduxjs/toolkit";
import { autonomosInitState, autonomosReducer } from "./reducer";

export const AUTONOMOS_SLICE_NAME = "AUTONOMOS";

const autonomosSlice = createSlice({
  name: AUTONOMOS_SLICE_NAME,
  initialState: autonomosInitState,
  reducers: autonomosReducer,
});

export const actions = autonomosSlice.actions;

export default autonomosSlice.reducer;
